import { render, staticRenderFns } from "./No22.vue?vue&type=template&id=34f21f83&scoped=true"
import script from "./No22.vue?vue&type=script&lang=js"
export * from "./No22.vue?vue&type=script&lang=js"
import style0 from "./No22.vue?vue&type=style&index=0&id=34f21f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f21f83",
  null
  
)

export default component.exports